import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";


const DashboardLayout = () => {
const [expanded, setExpanded] = useState(false);   // desktop
const [isOpen, setIsOpen] = useState(false);      // mobile

const toggleSidebar = () => {
  if (window.innerWidth < 768) {
    setIsOpen(prev => !prev);   // mobile
  } else {
    setExpanded(prev => !prev); // desktop
  }
};



  return (
    <div className="bg-grey h-screen ">
<Navbar toggleSidebar={toggleSidebar} />

      <div className="flex">
<Sidebar expanded={expanded} isOpen={isOpen} setIsOpen={setIsOpen} />

        <div className={`w-full bg-grey h-full px-3  pt-[20px]`}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;